import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EtsConfigService } from '../ets-config-service/ets-config.service';

@Injectable({
  providedIn: 'root'
})
export class OrderhistoryService {

  constructor(@Inject('ETS_API_URL') public apiUrl: string, public httpClient: HttpClient, private config: EtsConfigService) { }



  public GetOrderHistory(): Observable<any> {

    const headers = this.getHttpHeaders();
    return this.httpClient.get(this.apiUrl + 'customer/history', { headers });
  }

  public getPrintAtHomeTicket(orderNumber: number, orderCode: number): Observable<Blob> {
    let headers = this.getHttpHeaders();
    headers = headers.append('responseType', 'blob');

    return this.httpClient.get(this.apiUrl + 'customer/history/printathome', {
      headers, responseType: 'blob', params: {
        orderCode: orderCode,
        orderNumber: orderNumber
      }
    });
  }

  /**
   * Returns header with partnershopID for HTTP-Requests
   *
   * @returns HttpHeaders
   */
  private getHttpHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('partnershopId', this.config.getShopIdentifier());
    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('ets-login-token-' + this.config.getShopIdentifier()));

    if (this.config.serverCookie !== '') {
      headers = headers.append('X-Server', this.config.serverCookie);
    }

    return headers;
  }


}
